<ng-template [cdkPortalOutlet]="dynamicLayoutPortal"></ng-template>
